import React from "react";

const Footer = () => {
  return (
    <footer
      className="fixed w-full bottom-0 bg-blue rounded-t-[60px] 
    "
    >
      <div className="hidden sm:block container py-2 3xl:py-2.5 text-center">
        <p className="text-lg xl:!text-sm 3xl:!text-lg text-white font-interRegular">
          Copyright Dental-Labor Schreiber GmbH © 2026. Alle Rechte vorbehalten
        </p>
      </div>
    </footer>
  );
};

export default Footer;
